import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import {
  Chevron,
  Storage,
  Resume,
  Thesis,
  Journals,
  Support,
  SignOut,
  Account,
  Pricing,
  Refer,
  Subscription,
  HistoryEdu,
  AboutUs,
  Login,
  ResumeService,
  ServicesIcon,
} from '../../cra/src/components/userDocuments/editDocument/editJournal/toolset/assets/icons';
import './Accordion.css';
import { BetaTag, BETA } from './Toolbar/ToolbarItems/url';

const AccordianSection = styled.div`
  display: flex;
  flex-direction: column;

  /* Style the buttons that are used to open and close the accordion panel */
  .accordion {
    background-color: #ffffff;
    color: #444;
    cursor: pointer;
    padding: 10px 14px;
    display: flex;
    align-items: center;
    border: none;
    outline: none !important;
    transition: background-color 0.6s ease;
  }

  .thesisLogo {
    margin-left: -4px;
    margin-right: 4px;
  }

  .journalLogo {
    margin-left: -2px;
    margin-right: 3px;
  }

  .accordion__title {
    font-size: 14px;
    text-align: left;
    margin-left: 12px;
    margin-bottom: 0;
  }

  /* Style the accordion chevron icon */
  .accordion__icon {
    margin-left: auto;
    transition: transform 0.6s ease;
  }

  /* Style to rotate icon when state is active */
  .rotate {
    transform: rotate(90deg);
  }

  /* Style the accordion content panel. Note: hidden by default */
  .accordion__content {
    background-color: white;
    overflow: hidden;
    transition: max-height 0.6s ease;
  }

  /* Style the accordion content text */
  .accordion__text {
    font-family: 'Open Sans', sans-serif;
    font-weight: 400;
    font-size: 14px;
    padding: 18px;
  }
`;

const Button = styled.button`
  background-color: #ffffff;
  color: #444;
  cursor: pointer;
  padding: 10px 24px;
  display: flex;
  align-items: center;
  border: none;
  outline: none !important;
  transition: background-color 0.6s ease;
`;

const Para = styled.p``;

const AccordianContent = styled.div``;

class Accordion extends Component {
  state = {
    setActive: '',
    setHeight: 0,
    setRotate: 'accordion__icon',
  };

  content = React.createRef(null);

  toggleAccordion = () => {
    const { setActive } = this.state;
    this.setState({
      setActive: setActive === '' ? 'active' : '',
      setHeight:
        setActive === 'active' ? '0' : `${this.content.current.scrollHeight}px`,
      setRotate:
        setActive === 'active' ? 'accordion__icon' : 'accordion__icon rotate',
    });
  };

  renderLogo = (logoTitle) => {
    if (logoTitle === 'My Drive') {
      return <Storage />;
    }
    if (logoTitle === 'Resume' || logoTitle === 'Cover Letter') {
      return <Resume />;
    }
    if (logoTitle === 'Features' || logoTitle === 'Features') {
      return <Resume />;
    }
    if (logoTitle === 'thesis') {
      return <Thesis className="thesisLogo" />;
    }
    if (logoTitle === 'journal') {
      return <Journals className="journalLogo" />;
    }
    if (logoTitle === 'Support') {
      return <Support />;
    }
    if (logoTitle === 'Sign out') {
      return <SignOut />;
    }
    if (logoTitle === 'Account & Settings') {
      return <Account />;
    }
    if (logoTitle === 'My Plan') {
      return <Subscription fill="rgb(71, 56, 128)" />;
    }
    if (logoTitle === 'Pricing') {
      return <Pricing fill="rgb(71, 56, 128)" />;
    }
    if (logoTitle === 'Refer') {
      return <Refer fill="rgb(71, 56, 128)" />;
    }
    if (logoTitle === 'Feedback') {
      return <Support fill="rgb(71, 56, 128)" />;
    }
    if (logoTitle === 'Blogs') {
      return <HistoryEdu fill="rgb(71, 56, 128)" />;
    }
    if (logoTitle === 'AboutUs') {
      return <AboutUs fill="rgb(71, 56, 128)" />;
    }
    if (logoTitle === 'Login') {
      return <Login fill="rgb(71, 56, 128)" />;
    }
    if (logoTitle === 'Review Services') {
      return <ResumeService />;
    }
    if (logoTitle === 'Services') {
      return <ServicesIcon />;
    }
    return null;
  };

  render() {
    const { children, title, fill, logoTitle, beta } = this.props;
    const { setActive, setHeight, setRotate } = this.state;

    return (
      <AccordianSection>
        <Button
          className={`accordion ${setActive}`}
          onClick={this.toggleAccordion}
          type="button"
          data-testid="toggle__accordian"
        >
          {this.renderLogo(logoTitle)}
          <Para className="accordion__title">{title}</Para>
          {beta && (
            <BetaTag id="beta-tag">
              <span>{BETA}</span>
            </BetaTag>
          )}
          <Chevron
            className={`${setRotate}`}
            width="24px"
            height="24px"
            fill={fill || '#473880'}
          />
        </Button>
        <AccordianContent
          ref={this.content}
          style={{ maxHeight: `${setHeight}` }}
          className="accordion__content"
        >
          {children}
        </AccordianContent>
      </AccordianSection>
    );
  }
}

Accordion.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string.isRequired,
  fill: PropTypes.string,
  logoTitle: PropTypes.string.isRequired,
};

Accordion.defaultProps = {
  fill: undefined,
  children: <></>,
};

export default Accordion;
